"use client";

import React from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const narrativeBlocks = [{
  type: "text",
  content: "At VOW, we believe a wedding is more than an event; it is a living masterpiece. Our philosophy is rooted in the pursuit of effortless elegance, where every architectural detail and floral arrangement serves a singular purpose: to frame your love story in its most exquisite light."
}, {
  type: "quote",
  content: "We don't just host celebrations. We curate timeless legacies of love."
}, {
  type: "text",
  content: "Our approach is defined by a meticulous attention to the unseen. From the way the golden hour light hits our grand ballroom to the precise placement of hand-pressed linens, we orchestrate an environment where luxury feels natural and every moment feels intentional."
}, {
  type: "quote",
  content: "true luxury lies in the seamless harmony of vision, venue, and emotion."
}, {
  type: "text",
  content: "By offering a comprehensive, full-service experience, we remove the friction of planning, allowing you to remain present in the magic. Our dedicated team transforms your aspirations into a sensory reality that resonates long after the final toast is made."
}];
function NarrativeBlock({
  block,
  index
}: {
  block: any;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.5,
    once: false
  });
  return <div data-index={index} ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      {block.type === "quote" ? <blockquote className="my-12 border-l-4 border-secondary pl-6 py-2">
          <p className="text-3xl md:text-4xl lg:text-5xl font-medium font-default text-primary leading-tight tracking-tight">
            "{block.content}"
          </p>
        </blockquote> : <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-sans">
          {block.content}
        </p>}
    </div>;
}
export default function TheVowPhilosophy() {
  return <section data-section-id="223949" id="the-vow-philosophy" className="bg-background text-foreground py-16 md:py-24 px-4 md:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-start lg:h-[800px]">
          
          {}
          <div className="relative h-[500px] lg:h-full w-full rounded-md bg-card/50 border border-border/30 p-6 md:p-10 shadow-md">
            {}
            <div className="absolute top-0 left-0 right-0 h-12 bg-gradient-to-b from-background to-transparent z-10 pointer-events-none rounded-t-md" />
            <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-background to-transparent z-10 pointer-events-none rounded-b-md" />
            
            <ScrollArea className="h-full pr-6">
              <div className="space-y-12 py-12">
                <div className="mb-16">
                  <div className="w-12 h-px bg-secondary mb-6" />
                  <h2 className="text-sm font-medium tracking-widest text-secondary uppercase mb-4 font-mono">
                    The VOW Philosophy
                  </h2>
                  <h3 className="text-4xl md:text-6xl font-light font-default tracking-tight text-primary">
                    A Full-Service Legacy
                  </h3>
                </div>

                {narrativeBlocks.map((block, i) => <NarrativeBlock key={i} block={block} index={i} />)}
                
                {}
                <div className="h-32" />
              </div>
            </ScrollArea>
          </div>

          {}
          <div className="relative h-[600px] lg:h-full w-full hidden md:block">
            <div className="absolute inset-0 w-full h-full">
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683483/img/vow_estate_garden_soft.png" alt="VOW Estate Garden" className="absolute top-0 left-0 w-[65%] h-[55%] object-cover rounded-md grayscale opacity-40 shadow-lg transition-transform duration-1000 hover:scale-105" />
              
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683483/img/vow_interior_details.png" alt="Elegant interior details" className="absolute bottom-0 right-0 w-[70%] h-[60%] object-cover rounded-md grayscale opacity-30 shadow-lg transition-transform duration-1000 hover:scale-105" />
              
              {}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60%] h-[50%] z-20">
                <div className="w-full h-full relative rounded-md overflow-hidden shadow-2xl border-8 border-background ring-1 ring-border">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683483/img/vow_lead_planner_portrait.png" alt="VOW Lead Planner" className="w-full h-full object-cover transition-transform duration-700 hover:scale-110" />
                  {}
                  <div className="absolute inset-0 pointer-events-none mix-blend-overlay" />
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="md:hidden flex flex-col gap-6 mt-8">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683483/img/vow_lead_planner_portrait.png" alt="VOW Lead Planner" className="w-full h-auto max-h-[400px] object-contain rounded-md shadow-md border-4 border-background bg-card/30" />
            <div className="grid grid-cols-2 gap-4">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683483/img/vow_estate_garden_soft.png" alt="VOW Estate Garden" className="w-full h-40 object-cover rounded-md grayscale opacity-70" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683483/img/vow_interior_details.png" alt="Elegant interior details" className="w-full h-40 object-cover rounded-md grayscale opacity-70" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}